import { Text } from "@solomon-labs/design/components/ui";
import React from "react";

import { IndicationUnit } from "../../components/Metrics/IndicationUnit";

interface YaasPositionBalanceProps {
    /** Pre-formatted USD value, e.g. "$12,450.75". The card uses
     *  `position.position.formattedUSDvValue` from the
     *  YaasPositionCardData shape. */
    formatted: string;
}

/**
 * Balance value row — leading IndicationUnit `top` dot + the headline
 * number + "USDv" unit suffix, baseline-aligned (matches the v3
 * calculator treatment so the unit reads as a suffix on the same
 * line as the digits). The dot uses `pairWith="number-lg"` so its
 * size + top-padding track the number-lg type scale at both
 * breakpoints.
 *
 * The "Account Balance" / "Holding" label and the status pill sit
 * in a separate row above this one (still inside the card itself).
 */
export function YaasPositionBalance({
    formatted
}: YaasPositionBalanceProps): React.ReactElement {
    return (
        <div className="flex items-baseline gap-1">
            <IndicationUnit variant="top" pairWith="number-lg" />
            <Text
                variant="number-lg"
                className="text-foreground-base tabular-nums"
            >
                {formatted}
            </Text>
            <Text
                variant="fine-print"
                render={<span />}
                className="text-foreground-muted"
            >
                Total USDv
            </Text>
        </div>
    );
}
